import { styled } from '@/core/ui';
export const GroupedListItemTopAnchor = styled('span')({
    display: 'flex',
    height: 0,
    padding: 0,
    width: 0,
});
